import axios, { AxiosInstance } from "axios"

export class API {
  private http: AxiosInstance

  constructor() {
    this.http = axios.create({
      baseURL: '/api',
      timeout: 10000,
      headers: {
      },
    });
  }

  public getConsonants(): Promise<any[]> {
    return this.getOptionList('consonants');
  }

  public getVowels(): Promise<any[]> {
    return this.getOptionList('vowels');
  }

  public getTones(): Promise<any[]> {
    return this.getOptionList('tones');
  }
  
  public async getOptionList(resourceName: string): Promise<any[]> {
    const res = await this.http.get(resourceName);
    return (res.statusText === 'OK' && res.data) ? res.data : [];
  }
  
  public async searchWords(parameters: {[key: string]: string}): Promise<any> {
    const res = await this.http.get('words', { params: parameters, });
    return res;
  }
  
  public async getWord(wordId: number): Promise<any> {
    const res = await this.http.get(`words/${wordId}`);
    return res;
  }
  
  public async saveWord(word: any): Promise<any> {
    if (word.wordId > 0) {
      return await this.http.put(`words/${word.wordId}`, word);
    } else {
      return await this.http.post(`words`, word);
    }
  }
  
  public async deleteWord(wordId: number): Promise<any> {
    const res = await this.http.delete(`words/${wordId}`);
    return res;
  }
}
